import { render } from "./component-status.vue?vue&type=template&id=4937c442"
import script from "./component-status.vue?vue&type=script&setup=true&lang=js"
export * from "./component-status.vue?vue&type=script&setup=true&lang=js"

import "./component-status.vue?vue&type=style&index=0&id=4937c442&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/components/component-status.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4937c442"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4937c442', __exports__)) {
    api.reload('4937c442', __exports__)
  }
  
  module.hot.accept("./component-status.vue?vue&type=template&id=4937c442", () => {
    api.rerender('4937c442', render)
  })

}


export default __exports__